/*
 *
 * MultiMerchantSelect
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 20-Nov-2024
 */

import MultiMerchantSelect from './MultiMerchantSelectContainer'

export default MultiMerchantSelect
